import React, { useState } from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { changePassword } from '../../../MyApi/core/changepassword'

import ChangePasswordForm from '../../../Components/core/profile/changepassword'
import PageHeader from '../../../Components/UI/PageHeader'


const ChangePassword = () => {
  const [old_password , setOldPassword]=useState("")
  const [new_password , setNewPassword]=useState("")
  const [confirmPassword , setConfirmPassword] =useState("")
  const [error ,setError]=useState("")
const mutation = useMutation("changePassword" ,(postData)=> changePassword(postData) ,{
  onSuccess:(data)=>{
    toast.success(`${data.message}`)
    setOldPassword("")
    setNewPassword("")
    setConfirmPassword("")
  },
  onError:(error)=>{
    toast.error(`${error.response.data.message}`)
  }
})

const handelPostRequest =()=>{
  if(new_password !==confirmPassword){
    setError("Passwords do not match")
    return
  }else{
    setError("")
    mutation.mutate({
    old_password,
    new_password

  })
  }
  
}
    const isdisbled=()=>{
        return false;
    }
  return (
    <div>
        <PageHeader title="تغيير كلمة المرور" saveButton handlePostRequest={handelPostRequest}  isdisbled={isdisbled}/> 
        <ChangePasswordForm setError={setError} error={error} setOldPassword={setOldPassword} setNewPassword={setNewPassword} setConfirmPassword={setConfirmPassword} />
    </div>
  )
}

export default ChangePassword